// Blocks the right-click menu and image dragging on product images: the gallery, its thumbnails and the lightbox.
// Uses delegation on the document so images re-rendered on variant change or opened in quick add are covered too.
// This deters casual saving only; the image files are still reachable through the page source or network tools.
if (!window.productImageProtect) {
  window.productImageProtect = true;

  const PROTECTED_IMAGES = 'media-gallery img, .product-media-modal__content img, .thumbnail-list img';

  ['contextmenu', 'dragstart'].forEach((type) => {
    document.addEventListener(type, (event) => {
      if (event.target.closest?.(PROTECTED_IMAGES)) event.preventDefault();
    });
  });
}
